// store/index.js
import Vue from 'vue'
import Vuex from 'vuex'
import { getMenuTree } from '@/api/menu'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token'),
    username: localStorage.getItem('username'),
    menuTree: []
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_USERNAME(state, username) {
      state.username = username
      localStorage.setItem('username', username)
    },
    SET_MENU_TREE(state, tree) {
      state.menuTree = tree
    },
    CLEAR_AUTH(state) {
      state.token = null
      state.username = null
      state.menuTree = []
      localStorage.removeItem('token')
      localStorage.removeItem('username')
    }
  },
  actions: {
    async loadMenuTree({ commit }) {
      const tree = await getMenuTree()
      commit('SET_MENU_TREE', tree)
      return tree
    },
    logout({ commit }) {
      commit('CLEAR_AUTH')
    }
  }
})